import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import ReviewList from './views/ReviewList.vue'
import ReviewDetail from './views/ReviewDetail.vue'
import SigninMentor from '@/components/SigninMentor'
import checktoken from '@/views/checktoken'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/review-list',
      name: 'reviewList',
      component: ReviewList
    },
    {
      path: '/review-detail',
      name: 'reviewDetail',
      component: ReviewDetail
    },
    {
      path: '/signin-mentor/:status',
      component: SigninMentor
    },
    {
      path: '/token/:tokenreview',
      name: 'checktoken',
      component: checktoken
    },
  ]
})
